<template>
  <div id="app">
    <div class="columns">
      <div class="column">
        <h1 class="title">PowerNine.com</h1>
      </div>
    </div>
    <div class="columns">
      <div class="column is-2">
        <aside class="menu">
          <p class="menu-label">Buy From Us</p>
          <ul class="menu-list">
            <li><form action="/buy/search"><p class="control has-addons"><input style="width: 10rem;" class="input" name="card_name" type="text" placeholder="Simple Search"> <button type="submit" class="button is-primary">Go</button></p></form></li>
            <li><router-link v-bind:class="{'is-active': $route.name === 'BuyAdvancedSearch'}" :to="{name: 'BuyAdvancedSearch'}">Advanced Search</router-link></li>
            <li><router-link v-bind:class="{'is-active': $route.name === 'Browse' || $route.name === 'ViewCategory'}" :to="{name: 'Browse'}">Browse</router-link></li>
            <li><router-link v-bind:class="{'is-active': $route.name === 'Cart'}" :to="{name: 'Cart'}">Cart</router-link></li>
          </ul>
          <p class="menu-label">Sell To Us</p>
          <ul class="menu-list">
            <li><a href="http://powernine.com.s3-website-us-east-1.amazonaws.com/buylist-full.html">Full List</a></li>
            <li><a href="http://powernine.com.s3-website-us-east-1.amazonaws.com/buylist-abridged.html">Abridged List</a></li>
            <li><router-link v-bind:class="{'is-active': $route.name === 'SellBrowse'}" :to="{name: 'SellBrowse'}">Browse</router-link></li>
            <li><router-link v-bind:class="{'is-active': $route.name === 'SellCart'}" :to="{name: 'SellCart'}">Cart</router-link></li>
          </ul>
          <p class="menu-label">More Info</p>
          <ul class="menu-list">
            <li><a href="https://www.facebook.com/PowerNineCom">Facebook</a></li>
            <li><a href="https://www.facebook.com/pg/NetherWorld/events">Events</a></li>
            <li><router-link v-bind:class="{'is-active': $route.name === 'Contact'}" :to="{name: 'Contact'}">Contact Us</router-link></li>
          </ul>
        </aside>
      </div>
      <div class="column">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      categories: [],
      shopifyCheckoutId: null,
      client: null,
    };
  },
};
</script>

<style lang="scss">
  @import "./assets/css/application";

  body {
    font-family: courier;
    font-weight: bold;
  }

  div.loading {
    pointer-events: none;
    opacity: 0.5;
    background: #CCC;
  }

  input.quantity {
    min-width: 3rem;
  }

  th.clickable {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// App.vue?8bad9f24